export default [
    {
      path: '/manage-devices',
      component: () => import('@/admin/pages/ManageDevices'),
      name: 'ManageDevices',
    }
]
